import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CloseCircle, Eye } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { WidgetHeader } from '../../../../components/common/header/widgetHeader/WidgetHeader';
import { CustomChip } from '../../../../components/common/chip/Chip';
import { useAppSelector } from '@application/store/useStore';
import { UserStatusMap } from '@application/common/enums/user-status';
import { Tooltip } from '@mui/material';
import { PrimaryGrid } from '@ui/components/common/grid/PrimaryGrid';
export const DeclinedUserDialog = ({ open, handleClose }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const { newOrDeclinedUsers } = useAppSelector((state) => state.user);
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 1920));
    const isMdUp = useMediaQuery(theme.breakpoints.up(1920));
    const height = isXs ? 300 : isSm ? 300 : isMdUp ? 500 : 'auto';
    const columns = [
        {
            field: 'name',
            headerName: 'User',
            minWidth: 150,
            flex: 2,
            sortable: false,
            renderHeader: () => (_jsx(Tooltip, { title: 'User Name', arrow: true, children: _jsx("span", { children: "User" }) })),
            renderCell: (params) => (_jsx(Tooltip, { title: params.value || '', arrow: true, children: _jsx("span", { children: params.value }) }))
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.5,
            minWidth: 150,
            headerAlign: 'left',
            align: 'left',
            renderHeader: () => (_jsx(Tooltip, { title: 'User Status', arrow: true, children: _jsx("span", { children: "Status" }) })),
            renderCell: (params) => (_jsx(Tooltip, { title: UserStatusMap.get(params.value) || '', arrow: true, children: _jsx(CustomChip, { value: UserStatusMap.get(params.value) }) })),
            sortable: false
        },
        {
            field: 'review request',
            headerName: 'Review request',
            flex: 1,
            minWidth: 150,
            headerAlign: 'left',
            align: 'left',
            renderHeader: () => (_jsx(Tooltip, { title: 'Review User Requests', arrow: true, children: _jsx("span", { children: "Review request" }) })),
            renderCell: (params) => {
                const id = params.row.id;
                return (_jsx(Tooltip, { title: 'View Review Request', arrow: true, children: _jsx(IconButton, { onClick: () => navigate(`/users-decline-user?${new URLSearchParams({ id }).toString()}`), children: _jsx(Eye, {}) }) }));
            },
            sortable: false
        }
    ];
    const rows = newOrDeclinedUsers?.map((user) => ({
        id: user.id,
        name: user.name,
        status: user.status
    })) || [];
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: false, PaperProps: {
            sx: {
                overflow: 'hidden',
                borderRadius: '25px',
                width: '90%',
                maxWidth: '840px'
            }
        }, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: [_jsx(DialogTitle, { style: { padding: 0 }, children: _jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { fontWeight: 500, fontSize: '20px', color: 'black', children: "Declined user requests" }), _jsx(IconButton, { onClick: handleClose, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }) }), _jsx(DialogContent, { children: _jsx(PrimaryGrid, { rows: rows, columns: columns, disableColumnSelector: true, disableRowSelectionOnClick: true, disableColumnMenu: true, disableColumnFilter: true, hideFooterPagination: true, hideFooterSelectedRowCount: true, hideFooter: true, sx: {
                        '& .MuiDataGrid-cell:focus': {
                            outline: 'none'
                        },
                        '& .MuiDataGrid-cell:focus-within': {
                            outline: 'none'
                        }
                    } }) })] }));
};
